import { Fancybox } from "@fancyapps/ui";

Fancybox.getDefaults().Hash = false;

Fancybox.bind('[data-fancybox]', {
    theme: "light",
    Carousel: {
        transition: 'slide',
    },
    Images: {
        protected: false,
    },
    Toolbar: {
        display: {
            left: [
                'infobar',
            ],
            middle: [],
            right: [
                'iterateZoom',
                // 'slideshow',
                // 'fullscreen',
                // 'download',
                // 'thumbs',
                'close'
            ],
        },
    },
});
